import { useEffect, useState } from "react";
import {
  getCampaigns,
  deleteCampaign,
  duplicateCampaign,
  cancelCampaign
} from "../services/campaign.api";
// import { useNavigate } from "react-router-dom";
  import { useHistory,useRouteMatch,} from "react-router-dom";
import { useSelector } from "react-redux";
export default function CampaignListScreen() {
const currentToken = useSelector((state)=>state?.user?.user?.token);
          const appToken = useSelector((state)=>state?.app?.app?.AppToken);
          
         const tenantId = useSelector((state)=>state?.user?.user?.user_id)

//   const navigate = useNavigate();
 const {url}=useRouteMatch();
  const history = useHistory();
  const [campaigns, setCampaigns] = useState([]);
  const [status, setStatus] = useState("");
  const [channel, setChannel] = useState("");

  useEffect(() => {
    fetchCampaigns();
  }, [status, channel]);

  async function fetchCampaigns() {
    const res = await getCampaigns({ status, channel,currentToken,appToken,tenantId, });
    setCampaigns(res.data);
  }

  return (
    <div style={{position:"relative",zIndex:99999}}>
      <h2>📢 Campaigns</h2>

      {/* <button onClick={() => navigate("/campaigns/create")}>
        + Create Campaign
      </button> */}

      <hr />

      <select onChange={e => setStatus(e.target.value)}>
        <option value="">All Status</option>
        <option value="scheduled">Scheduled</option>
        <option value="processing">Processing</option>
        <option value="completed">Completed</option>
        <option value="cancelled">Cancelled</option>
      </select>

      <select onChange={e => setChannel(e.target.value)}>
        <option value="">All Channels</option>
        <option value="push">Push</option>
        <option value="in_app">In-App</option>
        <option value="email">Email</option>
        <option value="sms">SMS</option>
        <option value="whatsapp">WhatsApp</option>
      </select>

      <hr />

      {campaigns.map(c => (
        <div key={c.id}>
          <h4>{c.name}</h4>
          <p>Channel: {c.channel}</p>
          <p>Status: {c.status}</p>

          <button onClick={() => history.push(`${url}/${c.id}`)}>
            View
          </button>

          {c.status === "scheduled" && (
            <button onClick={() => history.push(`${url}/edit/${c.id}`)}>
              Edit
            </button>
          )}

          {c.status === "scheduled" && (
            <button onClick={() => cancelCampaign(c.id,{currentToken,appToken,tenantId,})}>
              Cancel
            </button>
          )}

          <button onClick={() => duplicateCampaign(c.id,{currentToken,appToken,tenantId})}>
            Duplicate 
          </button>

          {["draft","cancelled"].includes(c.status) && (
            <button onClick={() => deleteCampaign(c.id,{currentToken,appToken,tenantId,})}>
              Delete
            </button>
          )}

          <hr />
        </div>
      ))}
    </div>
  );
}
